<template>
  <iframe :src="src" v-show="isLoaded" @load="loaded" @error="onError" />

  <LoadingIndicator v-if="!isLoaded && !isError" />

  <View v-if="isError" gap="md" direction="column" align="center">
    <Icon name="image-x" size="large" />
    <Text variant="body-large">Unable to load pdf file</Text>
  </View>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

import { Icon, LoadingIndicator, Text, View } from '@tallo/design-system';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps<{ src: string }>();
const isLoaded = ref(false);
const isError = ref(false);

function loaded() {
  isLoaded.value = true;
}

function onError() {
  isError.value = true;
}

watch(
  () => props.src,
  () => {
    isLoaded.value = false;
    isError.value = false;
  },
);
</script>

<style scoped lang="scss">
iframe {
  display: block;
  margin: auto;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
